export default __webpack_public_path__ + "static/media/pgmico(42).4cf41fe3.png";